import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';

import { resolveThemeOptions, THEME_OPTIONS } from '../core/theme.tokens';
import { ThemeOptions } from '../core/theme.types';
import { ThemeDomSyncService } from '../data-access/theme-dom-sync.service';
import { ThemeStore } from '../data-access/theme.store';

export function provideTheme(options: ThemeOptions = {}): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: THEME_OPTIONS,
      useValue: resolveThemeOptions(options),
    },
    provideAppInitializer(() => {
      inject(ThemeStore);
      inject(ThemeDomSyncService);
    }),
  ]);
}
